import React, { FC } from "react";
import { AdminHead } from "../../components/admin/AdminHead";
import Box from "@carrier-io/air-react/Box";
import { Typography } from "@carrier-io/air-react";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { addBulkUserTemplateUrl } from "../../utils/csvTemplate";
import { UploadUserFile } from "../../components/admin/bulkAddUser/UploadUserFile";

export const AddUsers: FC = () => {
  return (
    <>
      <AdminHead title="Upload Users via Bulk Upload" />
      <Box maxWidth="858px" width="100%" boxSizing="border-box">
        <Box padding="16px 32px">
          <Box marginTop="8px">
            <Typography variant="h5" sx={{ textAlign: "left" }}>
              Instructions
            </Typography>
          </Box>
          <Box marginTop="24px">
            <Typography variant="body1" sx={{ textAlign: "left" }}>
              Easily import multiple users at once using the provided
              standardized CSV template. This feature streamlines onboarding by
              allowing you to upload, validate, and manage user data in
              bulk—saving time and reducing manual errors.
            </Typography>
          </Box>
          <Box
            sx={{
              padding: "24px 32px",
              background: "#F1F3F5",
              marginTop: "24px",
            }}
          >
            <Typography variant="h6" sx={{ textAlign: "left" }}>
              Example data template
            </Typography>
            <Typography
              variant="body1"
              sx={{ textAlign: "left", marginTop: "24px" }}
            >
              Download the standardized .csv template, fill in the required user
              details in each column, and upload the completed file to import
              users in bulk.
            </Typography>
            <p />
            <Typography variant="body1" sx={{ textAlign: "left" }}>
              There are two example users in the template file to show how the
              data should be formatted. Delete these users before uploading the
              file.
            </Typography>
            <a
              rel="noreferrer"
              href={addBulkUserTemplateUrl}
              download="bulk_users_upload.csv"
              target="_blank"
              style={{
                fontFamily: "Nunito Sans",
                fontSize: "16px",
                display: "flex",
                alignItems: "center",
                width: "fit-content",
                justifyContent: "flex-start",
                fontWeight: 600,
                padding: "7px 16px",
                marginTop: "24px",
                border: "1px solid #A8C2FE",
                borderRadius: "4px",
                textDecoration: "none",
                color: "#1157FD",
              }}
            >
              <FileDownloadOutlinedIcon
                sx={{ color: "#1157FD", height: "24px", marginRight: "4px" }}
              />
              Download template file
            </a>
          </Box>
          <Box>
            <Typography
              variant="h5"
              sx={{ textAlign: "left", margin: "24px 0" }}
            >
              Upload Your List of users
            </Typography>
            <UploadUserFile />
          </Box>
        </Box>
      </Box>
    </>
  );
};
